import { p as prisma } from "../../../../chunks/prisma.js";
const load = (async () => {
  try {
    const users = await prisma.user.findMany({
      include: { role: true }
    });
    return { users };
  } catch (error) {
    console.log("Error getting users", error);
  }
  return {};
});
export {
  load
};
